module.exports = __webpack_public_path__ + "img/cooperation_bg_B@.54411f23.png";